export const STREAMING_VERBS = [
  'Sharpening pencils',
  'Taming the ledger',
  'Tallying',
  'Debiting',
  'Squaring the books',
  'Balancing',
  'Bean-counting',
  'Pestering your bank',
  'Cross-footing',
  'Accruing',
] as const;
